<template>
  <div class="mt-4">
    <div v-if="resultList.length === 0">
      <p class="text-caption text-medium-emphasis">
        Введіть текст для пошуку документів, завдань, контрагентів або
        протоколів.<br />
        Для пошуку по конкретних типах використовуйте теги:
        <span class="bg-grey-lighten-3">накази</span>,
        <span class="bg-grey-lighten-3">протоколи</span>,
        <span class="bg-grey-lighten-3">погодження</span>,
        <span class="bg-grey-lighten-3">підписання</span>,
        <span class="bg-grey-lighten-3">завдання</span>,
        <span class="bg-grey-lighten-3">контрагенти</span>.
      </p>
    </div>
    <div v-if="resultList.length" style="max-height: 450px; overflow-y: auto">
      <p class="text-caption">{{ resultCountText }}</p>
      <v-list>
        <v-list-item
          v-for="item in resultList"
          :key="`${item.type}-${item.id}`"
          @click="$router.push(item.route)">
          <template #prepend>
            <v-avatar size="32">
              <v-icon>{{ getIcon(item.type) }}</v-icon>
            </v-avatar>
          </template>
          <template #title>
            <div>
              {{ item.title }}
            </div>
          </template>

          <template #subtitle>
            <div class="d-flex flex-column">
              <span>
                {{ item.subtitle }}
              </span>
              <div class="text-caption">
                <span v-if="item.author">
                  Автор: ({{ getPersonName(item.author, { initials: true }) }})
                </span>
              </div>
            </div>
          </template>
          <template #append>
            <v-avatar size="32">
              <v-icon color="secondary">mdi-link</v-icon>
            </v-avatar>
          </template>
        </v-list-item>
      </v-list>
    </div>
    <div v-else-if="isSearch && resultList.length === 0" class="mt-5">
      <p class="text-caption text-error text-medium-emphasis">
        По вашому запиту нічого не знайдено
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { useGlobalSearch } from './index'
import { getPersonName } from 'best-modules/utils'
import { computed } from 'vue'

export default {
  methods: { getPersonName },
  setup() {
    const { resultList, isSearch } = useGlobalSearch()

    const resultCountText = computed(() => {
      const count = resultList.value.length

      if (count === 1) return 'Знайдено 1 збіг'
      if (count > 1 && count < 5) return `Знайдено ${count} збіги`

      return `Знайдено ${count} збігів`
    })

    const getIcon = (type: string) => {
      switch (type) {
        case 'order':
          return 'intime:order'
        case 'protocol':
          return 'intime:order'
        case 'documentAgreement':
          return 'intime:agreements'
        case 'documentSignature':
          return 'intime:sign'
        case 'task':
          return 'intime:task'
        case 'contractor':
          return 'intime:contractor'
        default:
          return 'mdi-help-circle-outline'
      }
    }

    return {
      getIcon,
      resultCountText,
      resultList,
      isSearch,
    }
  },
}
</script>
